import { all } from '@redux-saga/core/effects';
import { appSaga } from './app/sagas';
import { cleanersSaga } from './cleaners/sagas';
import { bookingsSaga } from './bookings/sagas';
import { chatSaga } from './chat/sagas';
import { reviewsSaga } from './reviews/sagas';
import { cardsSaga } from './cards/sagas';

export function* rootSaga() {
  yield all([
    appSaga(),
    cleanersSaga(),
    bookingsSaga(),
    chatSaga(),
    cardsSaga(),
    reviewsSaga(),
  ]);
}
